import { AbstractDTO } from "frontend-core";
import { AuthMethod, AuthStep, Credentials } from "../Models/Credentials";
import { ValidationRuleResult } from "frontend-core/dist/models/AbstractDTO";

export class CredentialsDTO extends AbstractDTO {
  constructor(protected readonly model: Credentials) {
    super(model);

    this.rules = {
      login: (): ValidationRuleResult => {
        return !!this.model.login || ["Проверьте логин"];
      },
      password: (): ValidationRuleResult => {
        return !!this.model.password || ["Проверьте пароль"];
      },
    };
  }

  public serialize(): ICredentialsDTOJson {
    if (this.model.f2aCode) {
      return {
        username: this.model.login,
        password: this.model.password,
        ya_captcha: this.model.ya_captcha,
        code: this.model.f2aCode,
        method: this.model.method,
        step: this.model.step,
      };
    }

    return {
      username: this.model.login,
      password: this.model.password,
      ya_captcha: this.model.ya_captcha,
      method: this.model.method,
      step: this.model.step,
    }
  }
}

export interface ICredentialsDTOJson {
  password: string;
  username: string;
  ya_captcha?: string;
  code?: string;
  method: AuthMethod;
  step: AuthStep;
}
